import { type ErrorInfo } from 'react';

export interface ErrorBoundaryContext {
  isFatal: boolean;
  name: string;
  [key: string]: unknown;
}

export type ErrorBoundaryPayload = {
  error: unknown;

  // React details https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
  errorInfo: ErrorInfo;
  ownerStack: string | undefined;

  // custom info
  context: ErrorBoundaryContext;
};

export type ErrorEvent = CustomEvent<ErrorBoundaryPayload>;

// https://devdocs.io/dom/customevent
export const ERROR_BOUNDARY_CUSTOM_EVENT_TYPE =
  'react-error-boundary-triggered';
